export const question = {
    labels: {},
    types: {
        title: "Title",
        input: "Text",
        textarea: "Long Text",
        select: "Selection",
        radio: "Options",
        checkbox: "Checkbox",
        file: "File",
        sign: "Signature",
    },
    file_types: {
        document: "Document",
        image: "Image",
    },
    texts: {
        add_question: "Add Question",
        edit_question: "Edit Question",
        del_question: "Delete Question",
        del_confirm: "Do you want to delete the question <strong>'{concat}'</strong>?",
    },
};